import { get } from "svelte/store";
import { sessionStore } from "../../stores/session";
import PATHS from "../../constants/routePaths";
import {
  thankYouCampaignUserResponse,
  globalPhaseCampaignUserResponse
} from "../../../scenarios/campaignUserResponses";
import type { CampaignUserResponse } from "../../api/campaign";
import { getMenuResponse } from "../../../scenarios/setupDummyMenu";

const DummyCampaignUserProvider = {
  get: () => {
    const { currentPath } = get(sessionStore);

    if (currentPath === PATHS.ADDRESS) {
      return {
        success: true,
        campaign_user: { ...globalPhaseCampaignUserResponse, current_status_updated_at: new Date().toISOString() }
      } as unknown as CampaignUserResponse;
    } else if (currentPath === PATHS.MENU) {
      return {
        success: true,
        campaign_user: { ...getMenuResponse(), current_status_updated_at: new Date().toISOString() }
      } as unknown as CampaignUserResponse;
    } else {
      return {
        success: true,
        campaign_user: { ...thankYouCampaignUserResponse, current_status_updated_at: new Date().toISOString() }
      } as unknown as CampaignUserResponse;
    }
  }
};

export default DummyCampaignUserProvider;
